<template>
  <div class="Freequote-main">
    <div class="Science-btn">
      <area-cascader  :level="1" type="text" :placeholder="cidata" v-model="city" :data="pcaa" @change="getChangeVal"></area-cascader>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { pca, pcaa } from 'area-data'; // 城市数据
import 'vue-area-linkage/dist/index.css'; // 样式
export default {
  components: {
    
  },
  props: ["cidatas"],
  watch: {
    cidatas: "getcidatas"
  },
  data(){
    return{
        pcaa:pcaa,
        valCity:'',
        areaCascader:'',
        city:[],
        cidata:''
    }
  },
  methods:{
   getChangeVal(){
     //console.log('ci',this.city);
     this.$emit('citydata',this.city)
   },
   getcidatas(){
     this.cidata = this.cidatas.province +'/'+this.cidatas.city +'/'+this.cidatas.area
   }
  }
}
</script>
<style scoped>
.Science-btn {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.area-cascader-wrap{
  width: 100%;
}
.Science-btn>>>.area-select.large{
 width: 100% ;
 float: left;
 text-align: left;
}
</style>
